import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { GetUserOrderSummaryResponse } from '@/backend/market/models/GetUserOrderSummaryResponse'
import { UserOrderSummaryEntity } from '../../domain/entities/UserOrderSummaryEntity'

export class UserOrderSummaryModel extends UserOrderSummaryEntity {
  constructor(dataDto: GetUserOrderSummaryResponse) {
    super()
    mapEntityProperties<UserOrderSummaryEntity>(this, dataDto)
  }
}
